import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60b2d6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Recruit ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Contact ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuPopOver = _resolveComponent("MenuPopOver")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "menuContainer",
    class: _normalizeClass(_ctx.menuStyle)
  }, [
    _createElementVNode("li", {
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
    }, [
      _createElementVNode("span", {
        onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseOver && _ctx.onMouseOver(...args))),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseOver && _ctx.onMouseOver(...args)))
      }, " Service ", 32),
      (_ctx.isHoverService)
        ? (_openBlock(), _createBlock(_component_MenuPopOver, {
            key: 0,
            platform: _ctx.screenInfo.isPlatform,
            path: _ctx.path,
            "show-up": _ctx.showUp,
            onOnClickItem: _ctx.onClickItem
          }, null, 8, ["platform", "path", "show-up", "onOnClickItem"]))
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("li", {
      class: _normalizeClass(_ctx.liStyle('Recruit'))
    }, [
      _createVNode(_component_router_link, { to: "/recruit" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.bulletClass('Recruit'))
          }, null, 2),
          _hoisted_1
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("li", {
      class: _normalizeClass(_ctx.liStyle('Contact'))
    }, [
      _createVNode(_component_router_link, { to: "/contact" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.bulletClass('Contact'))
          }, null, 2),
          _hoisted_2
        ]),
        _: 1
      })
    ], 2)
  ], 2))
}